/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-useless-computed-key */
import React, { Fragment, useState, useEffect, useRef } from 'react';
import MainHeader from "../../../../Shared/components/Header";
import SettingsImg from "../../../../../assets/images/icon_menus/SettingsIcon.json";
import { useDispatch, useSelector } from "react-redux";
import clsx from "clsx";
import { NavLink } from "react-router-dom";
import { Row, Col, Image, Space } from "antd";
import customStyles from "../../../../../assets/styles/customStyles";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import usePrevious from "../../../../Shared/components/Previous";
import crudActions from "../../../../CRUD/redux/actions";
import dayjs from 'dayjs';
import businessActions from "../../../../Admin/Home/redux/actions";
import { checkViewPermission, checkComponentPermission, exportCommonFile } from "../../../../../helpers/utilities";
import { TextField, FormControl, RadioGroup, FormControlLabel, Radio, } from "@mui/material";
import AddIcon from "../../../../../assets/images/icon_actions/Add Icon.svg";
import { SelectedIcon, UnSelectedIcon } from "../../../../Shared/components/Icons/selectedIcon";
import { QueryForm } from "./QueryForm";
import { ListTable } from "./ListTable";
import groupActions from "../../../../Sales/Setup/redux/actions";
import salesActions from "../../../../Sales/Management/redux/actions";
import { emptyValidation } from "../../../../../helpers/validation";
import ExportIcon from "../../../../../assets/images/icon_actions/Export.svg";
import PrintIcon from "../../../../../assets/images/icon_actions/Print.svg";
import addressActions from "../../../../Admin/Address/redux/actions";
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import { CustomModal } from "../../../../Shared/components/DeleteModal";
import { PrintDetails } from "./Blocks";
import ClearIcon from "../../../../../assets/images/icon_actions/Clear Icon.svg";


export default function DeliveryDetails(props) {
    const { roleManagement } = useSelector(state => state.authReducer);
    const { customerDetails } = useSelector(state => state.salesManagementReducer);
    const { customerGroupdetails } = useSelector(state => state.salesSetupReducer);
    const { getList, getLoader } = useSelector(state => state.crudReducer);
    const { pincodeDetails } = useSelector(state => state.addressReducer);
    const { businessDetails } = useSelector(state => state.homeReducer);

    const [search, setSearch] = useState('');
    const [iconAnimation, setIconAnimation] = useState(false);
    const prevSearch = usePrevious(search);
    const [selected, setSelected] = useState([]);
    const [visible, setVisible] = useState(false);
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("serialNo");
    const [productList, setProductList] = useState([]);
    const [customerList, setCustomerList] = useState([]);
    const [customerIds, setCustomerIds] = useState([]);
    const [print, setPrint] = useState(false);
    const [printVisible, setPrintVisible] = useState(false);

    const timeoutRef = useRef(null);
    const [searchForm, setSearchForm] = useState({});
    const [printForm, setPrintForm] = useState({
        type: 'checkList',
        checkList: 'detailed',
        format: 'original'
    });


    const dispatch = useDispatch();
    const [form, setForm] = useState({
        customerSpec: 'ALL'
    });

    const [error, setError] = useState({});
    const { history } = props;


    useEffect(() => {
        if (roleManagement !== '' && checkViewPermission('Delivery Details', history, 'Admin')) {
            dispatch({
                type: groupActions.CUSTOMERGROUP_DETAILS_START, url: 'customer-group', filter: {
                    order: 'id desc'
                }
            });
            dispatch({ type: businessActions.BUSINESS_DETAILS_START });
            dispatch({
                type: salesActions.CUSTOMER_DETAILS_START, url: 'customerProfile',
                filter: {
                    order: 'id desc'
                },
            });
            dispatch({ type: crudActions.CLEAR_GET_DETAILS_START });
        }
    }, [roleManagement]);



    useEffect(() => {
        if (getList) {
            if (getList?.customer_list) {
                setCustomerList(getList?.customer_list?.sort((a, b) => b[sortBy]?.localeCompare(a[sortBy])));
                let pinCodes = getList?.customer_list.map(item => item?.pincodeId);
                let pinCodesIds = [...new Set(pinCodes)];
                let cusDetails = customerDetails && customerDetails?.filter((cl) => {
                    return getList?.customer_list.some((el) => {
                        return cl.id === el.customerId
                    });
                });
                setCustomerIds(cusDetails);
                dispatch({
                    type: addressActions.PINCODE_DETAILS_START, url: 'pincode', filter: {
                        where: { id: { inq: pinCodesIds } }
                    }
                });
            }
            if (getList?.product_list) {
                setProductList(getList?.product_list);
            }
        }
    }, [getList]);


    const dispatchFilter = (form) => {
        let data = form.customerSpec + '/';
        if (form.customerSpec === "SPECIFIC") {
            if (form?.customerId) {
                data += form?.customerId + '/0/';
            }
        } else if (form.customerSpec === "GROUP") {
            if (form?.customerGroupId) {
                data += '0/' + form?.customerGroupId + '/';
            }
        } else {
            data += '0/0/';
        }

        data += (form?.fromDate ? dayjs(form.fromDate).format('YYYY-MM-DD') : 'blank') + '/';
        data += (form?.toDate ? dayjs(form.toDate).format('YYYY-MM-DD') : 'blank');

        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'salesLoadReport/' + data,
            skip: 0
        });
    }

    const handleFilter = (searchForm, search) => {
        let cDetails = getList?.customer_list; let pDetails = getList?.product_list;

        if (search !== '') {
            cDetails = cDetails?.filter((el) => {
                return (el?.serialNo?.match(new RegExp(search, "i")) ||
                    el?.selfBill?.serialNo?.match(new RegExp(search, "i")))
            });

            pDetails = pDetails && Object.fromEntries(
                Object.entries(pDetails).filter(([key, value]) => {
                    return value?.invoices?.some((el) => {
                        return (el?.serialNo?.match(new RegExp(search, "i")) ||
                            el?.selfBill?.serialNo?.match(new RegExp(search, "i")))
                    })
                }));
        }
        if (searchForm?.customerId || searchForm?.pincodeId) {
            cDetails = cDetails?.filter((el) => {
                return (el?.customerId === searchForm?.customerId || el?.pincodeId === searchForm?.pincodeId)
            });

            pDetails = pDetails && Object.fromEntries(
                Object.entries(pDetails).filter(([key, value]) => {
                    return value?.invoices?.some((el) => {
                        return (el?.customerId === searchForm?.customerId || el?.pincodeId === searchForm?.pincodeId)
                    })
                }));
        }
        setProductList(pDetails);
        setCustomerList(cDetails);
    }

    const changeHandler = (e, name = '') => {
        if (name !== '') {
            setForm({
                ...form,
                [name]: e,
            });
        } else {
            setForm({
                ...form,
                [e.target.name]: e.target.value,
            });
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        let group = true;
        let customer = true;
        let emptyGroup = '';
        let emptyCustomer = '';
        if (form.customerSpec === 'GROUP') {
            emptyGroup = emptyValidation('Customer Group', form.customerGroupId);
            group = emptyGroup.isValid;
        } else if (form.customerSpec === 'SPECIFIC') {
            emptyCustomer = emptyValidation('Customer', form.customerId);
            customer = emptyCustomer.isValid;
        }
        if (group && customer) {
            dispatchFilter(form);
            setVisible(!visible);
            setSearchForm({});
        } else {
            setError({
                'groupId': emptyGroup.errors,
                'customerId': emptyCustomer.errors,
            })
        }
    }

    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    const handleClose = () => {
        setVisible(!visible);
    }

    useEffect(() => {
        if ((prevSearch !== undefined && search && search?.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                handleFilter(searchForm, '');
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    handleFilter(searchForm, search);
                }, 500);
            }
        }
    }, [search]);

    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        if (customerList) {
            if (sortOrder === 'desc') {
                setCustomerList(customerList.sort((a, b) => b[sortBy]?.localeCompare(a[sortBy])));
            } else {
                setCustomerList(customerList.sort((a, b) => a[sortBy]?.localeCompare(b[sortBy])));
            }
        }
    }

    const handleClick = (id) => {
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected?.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }
        setSelected(newSelected);
    };

    const changeSearchHanadler = (id, name = '') => {
        let data = {
            ...searchForm,
            [name]: id
        };
        setSearchForm(data);
        handleFilter(data, search);
    }

    const changePrintHandler = (id, name) => {
        setPrintForm({
            ...printForm, [name]: id
        })
    }

    const handlePrintView = () => {
        if (printForm?.type === 'checkList') {
            if (printForm?.checkList === '') {

            }

        } else if (printForm?.type === 'checkList') {

        } else {

        }
        setPrintVisible(true);
        setPrint(false);
    }


    const handlePrint = (print, id = '', pId = '') => {
        setPrint(true);
        setPrintForm({
            print: print,
            type: print === 'single' ? 'delivery' : 'checkList',
            checkList: print === 'productSingle' ? 'summary' : 'detailed',
            format: 'original',
            printId: id,
            productInvoiceId: pId
        });
    }

    const handleProductDetailsPrint = () => {

    }

    const classes = customStyles();

    return (
        <Fragment>
            <MainHeader {...props}
                img={SettingsImg}
                title={'Admin'}
                links={[{ 'label': 'Admin', 'link': '/admin' }, { 'label': 'Delivery Details', 'link': '' }]}
            />
            <div className={clsx(classes.margin40, classes.listTableMargin, classes.deliveryDetails)}>
                <PrimaryCard
                    title={'Delivery Details'}
                    component={
                        <>
                            <Row align="middle" className={classes.marginBottom20}>
                                <Col xxl={6} xl={7} lg={8} md={10} sm={13} xs={24}>
                                    {
                                        roleManagement !== '' && checkComponentPermission('Delivery Details', 'Action', 'Search') &&
                                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation || search !== '' })}>
                                            <TextField autoComplete='one-time-code'
                                                placeholder='Search Invoice Number'
                                                type='search'
                                                value={search}
                                                className={classes.comInput}
                                                required
                                                variant={'standard'}
                                                onChange={(e) => setSearch(e.target.value)}
                                                fullWidth
                                                onFocus={() => setIconAnimation(true)}
                                                onBlur={() => setIconAnimation(false)}
                                            />
                                            <Image
                                                src={SearchIcon}
                                                preview={false}
                                            />
                                            {
                                                search && <NavLink to="#" onClick={() => setSearch('')} className={classes.searchClear}>
                                                    <Image
                                                        src={ClearIcon}
                                                        preview={false}
                                                    />
                                                </NavLink>
                                            }
                                        </div>
                                    }
                                </Col>
                                <Col xxl={18} xl={17} lg={16} md={14} sm={11} xs={24} className={clsx(classes.textAlignRight, classes.removeUnderline, classes.customerLabelNone, classes.vertiCalScrollOverFlowParent)}>
                                    <div className={classes.vertiCalScrollOverFlow}>
                                        <Space size={[20, 20]} direction="horizontal" align="center">
                                            {
                                                roleManagement !== '' && customerList?.length > 0 && checkComponentPermission('Delivery Details', 'Action', 'Pincode Filter') &&
                                                <AutoCompleteComponent
                                                    customLabel={"All Pincode"}
                                                    heads={[{ 'key': 'code', 'name': 'Pincode' }, { 'key': 'city', 'name': 'City', 'relation': 'name' }]}
                                                    details={pincodeDetails}
                                                    customClasses={classes.customWidth172P}
                                                    position={"bottom"}
                                                    variant={'outlined'}
                                                    parentValue={customObject(pincodeDetails, searchForm?.pincodeId)}
                                                    onChangeText={(data) => {
                                                        if (data === '') {
                                                            changeSearchHanadler('', 'pincodeId');
                                                        }
                                                    }}
                                                    onChange={(data) => changeSearchHanadler(data.id, 'pincodeId')}
                                                />
                                            }
                                            {
                                                roleManagement !== '' && customerList?.length > 0 && checkComponentPermission('Delivery Details', 'Action', 'Customer Filter') &&
                                                <AutoCompleteComponent
                                                    customLabel={"All Customers "}
                                                    heads={[{ 'key': 'name', 'name': 'Name' }]}
                                                    details={customerIds}
                                                    customClasses={classes.customWidth172P}
                                                    position={"bottom"}
                                                    variant={'outlined'}
                                                    parentValue={customObject(customerIds, searchForm?.customerId)}
                                                    onChangeText={(data) => {
                                                        if (data === '') {
                                                            changeSearchHanadler('', 'customerId');

                                                        }
                                                    }}
                                                    onChange={(data) => changeSearchHanadler(data.id, 'customerId')}
                                                />
                                            }
                                            {
                                                roleManagement !== '' && customerList?.length > 0 && checkComponentPermission('Delivery Details', 'Action', 'Export') &&
                                                <NavLink
                                                    to="#"
                                                    onClick={() => exportCommonFile('Delivery Details', customerList, 'existing')}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={ExportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Export</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && selected?.length > 0 && checkComponentPermission('Delivery Details', 'Action', 'Bulk Print') &&
                                                <NavLink
                                                    to="#"
                                                    onClick={() => { handlePrint('multiple') }}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={PrintIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Bulk Print</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Delivery Details', 'Action', 'Run Load Query') &&
                                                <NavLink
                                                    to={"#"}
                                                    onClick={() => {
                                                        setVisible(!visible);
                                                        setForm({
                                                            customerSpec: 'ALL'
                                                        })
                                                    }}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={AddIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Run Load Query</span>
                                                </NavLink>
                                            }
                                        </Space>
                                    </div>

                                </Col>
                            </Row>
                            <ListTable
                                handleSelected={(value) => setSelected(value)}
                                handleClick={(id) => handleClick(id)}
                                loadTasks={() => dispatchFilter(form, sortBy, sortOrder)}
                                productList={productList}
                                customerList={customerList}
                                loadMore={getLoader}
                                loadMoreTask={() => { }}
                                loadMoreContent={false}
                                roleManagement={roleManagement}
                                sortOrder={sortOrder}
                                sortBy={sortBy}
                                classes={classes}
                                clsx={clsx}
                                handlePrint={(d, id, pId) => handlePrint(d, id, pId)}
                                selected={selected}
                                handleProductDetailsPrint={(id) => handleProductDetailsPrint(id)}
                                onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)} />
                        </>
                    }
                />
                <QueryForm
                    form={form}
                    error={error}
                    changeHandler={(e, name) => changeHandler(e, name)}
                    visible={visible}
                    handleClose={() => handleClose()}
                    classes={classes}
                    customObject={(details, id) => customObject(details, id)}
                    clsx={clsx}
                    handleSubmit={(e) => handleSubmit(e)}
                    customerDetails={customerDetails}
                    customerGroupdetails={customerGroupdetails}
                />
            </div>
            <CustomModal
                title={`${printForm?.print === 'multiple' ? 'Bulk Print' : 'Print'}`}
                visible={print}
                onOpen={() => handlePrintView()}
                onClose={() => {
                    setPrint(false);
                    setPrintVisible(false);
                    setPrintForm({
                        print: 'multiple',
                        type: 'checkList',
                        checkList: 'detailed',
                        format: 'original'
                    });
                }}
                yesButton={'OK'}
                noButton={'Cancel'}
                text={<div className={classes.removeUnderline}>
                    <FormControl
                        className={clsx(classes.margin10t, classes.dropDownPointer, classes.customRadioButton, classes.customQueryRadioButton)}
                        variant={'standard'}
                        fullWidth>
                        <RadioGroup
                            defaultValue={"ALL"}
                            aria-labelledby="demo-customized-radios"
                            name="type"
                            value={printForm?.type}
                            onChange={(e) => changePrintHandler(e.target.value, 'type')}>
                            {
                                (printForm?.print === 'multiple' || printForm?.print === 'productSingle') && <FormControlLabel value={'checkList'} control={<Radio
                                    checkedIcon={<UnSelectedIcon />}
                                    icon={<SelectedIcon />}
                                />} label="Product Delivery Check list" />
                            }
                            {
                                (printForm?.print === 'multiple' || printForm?.print === 'single') &&
                                <FormControlLabel value={'delivery'} control={<Radio
                                    checkedIcon={<UnSelectedIcon />}
                                    icon={<SelectedIcon />}
                                />} label="Delivery Challan" />
                            }
                            {

                                (printForm?.print === 'multiple' || printForm?.print === 'single') &&
                                <FormControlLabel value={'invoice'} control={<Radio
                                    checkedIcon={<UnSelectedIcon />}
                                    icon={<SelectedIcon />}
                                />} label="Invoice" />
                            }

                        </RadioGroup>
                    </FormControl>
                    {
                        printForm?.type === 'checkList' ?
                            <AutoCompleteComponent
                                name={["Choose the type of Check list "]}
                                heads={[{ 'key': 'name', 'name': 'Name' }]}
                                details={[{ name: 'Detailed', id: 'detailed' }, { name: 'Summary', id: 'summary' }]}
                                position={"bottom"}
                                customClasses={classes.margin30t}
                                parentValue={customObject([{ name: 'Detailed', id: 'detailed' }, { name: 'Summary', id: 'summary' }], printForm?.checkList)}
                                onChangeText={(data) => {
                                    if (data === '') {
                                        changePrintHandler('', 'checkList');
                                    }
                                }}
                                onChange={(data) => changePrintHandler(data.id, 'checkList')}
                            /> : <AutoCompleteComponent
                                name={["Choose the format "]}
                                heads={[{ 'key': 'name', 'name': 'Name' }]}
                                details={[{ name: 'Original', id: 'original' }, { name: 'Copy', id: 'copy' }]}
                                position={"bottom"}
                                customClasses={classes.margin30t}
                                parentValue={customObject([{ name: 'Original', id: 'original' }, { name: 'Copy', id: 'copy' }], printForm?.format)}
                                onChangeText={(data) => {
                                    if (data === '') {
                                        changePrintHandler('', 'format');
                                    }
                                }}
                                onChange={(data) => changePrintHandler(data.id, 'format')}
                            />
                    }
                </div>}
            />
            <PrintDetails
                form={printForm}
                visible={printVisible}
                classes={classes}
                clsx={clsx}
                selected={printForm?.print === 'productSingle' ? [printForm?.printId] : selected}
                details={
                    productList && Object?.fromEntries(
                        Object?.entries(productList).filter(([key, value]) => {
                            return value?.invoices?.some((el) => {
                                return printForm?.print === 'productSingle' ? [printForm?.printId].find(e => e === el.id) : selected.find(e => e === el.id)
                            })
                        }))
                }
                billDetails={
                    customerList && customerList?.filter((el) => {
                        return printForm?.print === 'multiple' ? selected.find(e => e === el.id) : el.id === printForm?.printId
                    })
                }
                businessDetails={businessDetails}
                handleClose={(v) => setPrintVisible(v)}
            />
        </Fragment>
    )
}